module.exports = __webpack_public_path__ + "static/Woman-0fc9c6f70e256d5a2aca861b5d8ac229.svg";